import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, signal, HostListener, HostBinding, ElementRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppSettings } from '@services/settings/app-settings.service';
import { HelpPanelComponent } from '../../../feature/management/help-management/components/help-panel/help-panel.component';

@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [CommonModule, HelpPanelComponent],
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageHeaderComponent {
  public appSettings = inject(AppSettings);
  @Input() title: string = '';
  @Input() mobileTitle?: string;
  @Input() icon?: string;
  @Input() optionsLabel: string = 'Opciones';
  @Input() optionsIcon: string = 'fa fa-cog';
  @Input() hasOptions: boolean = false;
  @Input() showBack: boolean = false;
  @Input() unifiedOnMobile: boolean = false;
  @Output() back = new EventEmitter<void>();

  // Enlaza la clase is-unified al elemento host para controlar el margen móvil
  @HostBinding('class.is-unified')
  get isUnified(): boolean {
    return this.unifiedOnMobile || this.showBack;
  }

  isOpen = signal<boolean>(false);
  private elementRef = inject(ElementRef);

  // Abre el menú de opciones
  openMenu(): void {
    this.isOpen.set(true);
  }

  // Cierra el menú de opciones
  closeMenu(): void {
    this.isOpen.set(false);
  }

  // Alterna la visibilidad del menú de opciones
  toggleMenu(): void {
    this.isOpen.update((open) => !open);
  }

  // Cierra el menú automáticamente al hacer clic en una opción interactiva
  onOptionClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (target.closest('.dropdown-item') || target.closest('button') || target.closest('a')) {
      this.closeMenu();
    }
  }

  // Cierra el menú en escritorio si se hace clic fuera del componente
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.isOpen() || window.innerWidth < 768) return;
    const target = event.target as HTMLElement;
    if (!this.elementRef.nativeElement.contains(target)) {
      this.closeMenu();
    }
  }
}
